import type { CategoryAttributeResponse } from "@/services/api";
import type { Category } from "@/services/api/categories";
import {
  sortBy,
  comparators,
  type SortDirection,
} from "@/shared/lib/sortUtils";

export type AttributeSortField = "name" | "categoriesLinked" | "valuesLinked";
export type AttributeSortDirection = SortDirection;

export interface AttributeWithCounts extends CategoryAttributeResponse {
  categoriesLinked: number;
  valuesLinked: number;
}

export function calculateCategoriesLinked(
  attributeId: number,
  categories: Category[]
): number {
  if (!categories) return 0;

  return categories.filter((category) =>
    category.attributes?.some((attr) => attr.attributeId === attributeId)
  ).length;
}

export function sortAttributes(
  attributes: AttributeWithCounts[],
  sortField: AttributeSortField,
  sortDirection: AttributeSortDirection
): AttributeWithCounts[] {
  return sortBy(attributes, sortField, sortDirection, {
    name: comparators.string((attr) => attr.name),
    categoriesLinked: comparators.number((attr) => attr.categoriesLinked),
    valuesLinked: comparators.number((attr) => attr.valuesLinked),
  });
}
